import { Flex, FormGroup, FormLabel, Grid } from "@eworkit/iris";
import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";

import { FormikDatePicker } from "@/components/Formik";
import { FormikError } from "@/components/Formik";
import { IConsultantProfile } from "@/data/consultant-profiles";
import { useFormats } from "@/hooks/Formats";
import { FormikCodelistSingleSelect } from "@/views/components/Codelists";

export interface IConsultantProfileAvailabiltySectionProps
  extends Pick<IConsultantProfile, "availability" | "availabilityDate"> {
  setAvailabilityDateField: (date: string | null) => void;
  onChange?: () => void;
}

export const AvailabilityForm: React.FC<IConsultantProfileAvailabiltySectionProps> = React.memo(props => {
  const { availability, availabilityDate, setAvailabilityDateField, onChange } = props;

  const { t } = useTranslation("session");
  const { formatDate } = useFormats();

  const onAvailabilityChange = (v: string) => {
    if (v === "SPECIFIC_DATE") {
      setAvailabilityDateField(moment().format("YYYY-MM-DD"));
    } else {
      setAvailabilityDateField(null);
    }
    onChange?.();
  };

  const onAvailabilityDateChange = (v: Date | null) => {
    setAvailabilityDateField(v ? v.toISOString() : null);
    onChange?.();
  };

  return (
    <Flex flexGrow={1} gap="sm" flexDirection="column">
      <Flex flexDirection="column">
        <FormGroup
          label={<FormLabel label={t("CONSULTANT_PROFILES.DETAIL.AVAILABILITY.NOTICE_PERIOD_LABEL")} required />}
          error={<FormikError name="availability" />}>
          <FormikCodelistSingleSelect
            codelistName="availability"
            name="availability"
            value={availability}
            onChange={onAvailabilityChange}
            size="xl"
            clearable={false}
          />
        </FormGroup>
      </Flex>

      {availability === "SPECIFIC_DATE" && (
        <Grid columns={["1fr", null, null, "1fr 1fr"]}>
          <Flex flexDirection="column">
            <FormGroup error={<FormikError name="availabilityDate" />}>
              <FormikDatePicker
                name="availabilityDate"
                placeholder={t("CONSULTANT_PROFILES.DETAIL.AVAILABILITY.AVAILABILITY_DATE_PLACEHOLDER")}
                onChange={onAvailabilityDateChange}
                size="xl"
                value={availabilityDate ? new Date(availabilityDate) : null}
                clearable>
                {formatDate(availabilityDate)}
              </FormikDatePicker>
            </FormGroup>
          </Flex>
        </Grid>
      )}
    </Flex>
  );
});
